/**
 * When we inline the html we get weird spacing in the treeview nodes
 * Probably a css selector issue which we can get back to later.
 */
angular.module('app').component('dvTraceSummary', {
    bindings: {},
    controllerAs: 'vm',
    controller: 'UtpTraceSummaryExController',
    templateUrl: 'scripts/app/partials/DataValidator/dv-trace-summary.tpl.html'
});
